import React from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import RouteIndex from './routers/routes/index';

import type { Theme } from '@mui/material/styles';

const theme: Theme = createTheme({
  typography: {
    fontFamily: ['Noto Sans JP', 'sans-serif'].join(',')
  }
});

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <RouteIndex />
  </ThemeProvider>
);

export default App;
